import stickybits from 'stickybits';

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('load', () => {
    const elements = document.querySelectorAll('.js-sticky');
    const mediaQueryList = window.matchMedia('(max-width: 1024px)');
    
    let stickyInstances = [];

    const getOffset = (el) => {
      const baseOffset = Number(el.dataset.offset || 0);
      return baseOffset;
    };

    const destroySticky = () => {
      stickyInstances.forEach(instance => instance.cleanup && instance.cleanup());
      stickyInstances = [];
    };

    const initSticky = () => {
      if (mediaQueryList.matches) {
        destroySticky(); 
        return;
      }

      destroySticky();
      elements.forEach(el => {
        const offset = getOffset(el);
        const sticky = stickybits(el, {
          stickyBitStickyOffset: offset
        });
        stickyInstances.push(sticky);
      });
    };

    if (elements.length > 0) {
      initSticky();
    }

    mediaQueryList.addEventListener('change', () => {
      initSticky();
    });

    window.addEventListener('resize', () => {
      initSticky();
    });
  });
});
